import { Badge, cn } from '@yakit/ui-components';

export const VDLLevel0TableNumberPosition = ({
  percent,
  isReversed,
  className
}: {
  percent: number;
  isReversed: number;
  className?: string;
}) => {
  const renderColor = (value: number, isReversed: number | null) => {
    let color: string = 'transparent';
    if (isReversed === 1) {
      if (value !== null) {
        if (value === 0 || value < 90) {
          color = '#22C55E';
        } else if (value < 98.99) {
          color = '#4ADE80';
        } else if (value < 99.99) {
          color = '#FDBA74';
        } else if (value < 101) {
          color = '#FFB3C1';
        } else {
          color = '#F87171';
        }
      }
    } else {
      if (value !== null) {
        if (value === 0 || value < 90) {
          color = '#F87171';
        } else if (value < 98.99) {
          color = '#FFB3C1';
        } else if (value < 99.99) {
          color = '#FDBA74';
        } else if (value < 101) {
          color = '#4ADE80';
        } else {
          color = '#22C55E';
        }
      }
    }
    return color;
  };

  return (
    <Badge
      className={cn(
        'flex h-[1.375rem] min-w-[2.208125rem] items-center justify-center',
        className
      )}
      style={{ backgroundColor: renderColor(percent, isReversed) }}
    >
      {percent}
    </Badge>
  );
};
